import React from 'react';
import { Accordion, AccordionLevelType, Box, Typography } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesFaqsItemClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { ActivitiesFaqsItemClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { FAQItemProps, FAQItemName } from 'component/page/detail/FAQSection/FAQSection.selectors';

const FAQItem: React.FC<FAQItemProps> = (props) => {
    const FAQ_CONTENT_HEADING_LEVEL: AccordionLevelType = 3;
    const onToggle = (itemName: FAQItemName) => (isExpanded: boolean) =>
        trackElementEvent<ActivitiesFaqsItemClickEventActivitiesFieldsV1>(
            ActivitiesFaqsItemClickEventActivitiesManifestV1.ids,
            {
                is_toggle_on: isExpanded,
            },
            {
                action_element_value: itemName.toString(),
            },
        );

    return (
        <Accordion
            actionType="chevron-icon"
            contentSummary={props.input}
            level={FAQ_CONTENT_HEADING_LEVEL}
            mt="16"
            view="collapsed"
            onToggle={onToggle(props.itemName)}
            data-element-name="activities-faqs-item"
        >
            <Typography variant="body-s" textColor="base.subtle" tag="span" my="12">
                <AgodaMarkdown input={props.output} />
            </Typography>
        </Accordion>
    );
};
FAQItem.displayName = 'FAQItem';

const FAQContent: React.FC = React.memo(() => {
    const cms = useSelector(selectCmsFromBootstrap);

    return (
        <Box px="12" data-testid="activities-faqs-content">
            <FAQItem input={cms[276904]} output={cms[276905]} itemName={FAQItemName.HowDoIBookAnActivity} />
            <FAQItem input={cms[276906]} output={cms[276907]} itemName={FAQItemName.WhoAndWhenDoIPay} />
            <FAQItem input={cms[276908]} output={cms[276909]} itemName={FAQItemName.HowDoVouchersWork} />
            <FAQItem input={cms[276910]} output={cms[276911]} itemName={FAQItemName.WhereCanIFindMyActivityBooking} />
            <FAQItem input={cms[276912]} output={cms[276913]} itemName={FAQItemName.HowCanICancelMyBooking} />
            <FAQItem input={cms[276914]} output={cms[276915]} itemName={FAQItemName.WhenWillIReceiveTheRefundForCancelledBookings} />
        </Box>
    );
});

FAQContent.displayName = 'FAQContent';

export { FAQItem, FAQContent };
